<template>
  <div class="inspection-comments-view">
    <div class="inspection-comments__comment" v-for="comment in props.comments" :key="moment(comment.DateAdded).unix()">
      <div
        :class="{
          last: isLastComment(comment),
        }"
        class="comment-header"
      >
        <div class="comment-header__author">
          {{ comment.WhoAdded }}
          <BadgeIndicator v-if="isLastComment(comment)" type="default" text="Latest Comment" />
        </div>
        <div class="comment-header__date">
          {{ moment(comment.DateAdded).format("MM/DD/YYYY h:mm a") }}
        </div>
      </div>
      <div
        :class="{
          last: isLastComment(comment),
        }"
        class="comment-body"
      >
        {{ comment.Comment }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { EirFormComment } from "@/Domain/EirFormComment";
import BadgeIndicator from "@/shared/ui/BadgeIndicator.vue";
import { useInspectionStore } from "@/stores/useInspectionStore";
import moment from "moment";

const inspectionStore = useInspectionStore();

const props = defineProps<{
  comments: EirFormComment[];
}>();

const isLastComment = (comment: EirFormComment) => {
  return inspectionStore.lastCommentDate?.getTime() == new Date(comment.DateAdded).getTime();
};
</script>

<style lang="scss" scoped>
.inspection-comments-view {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .inspection-comments__comment {
    padding: 16px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .comment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e9ecef;

    &__date {
      color: #666;
    }

    &.last {
      color: #007bff;
      border-bottom-color: #bbdefb;

      .comment-header__date {
        color: #3071b6;
      }
    }
  }

  .comment-header__author {
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .comment-body {
    white-space: pre-wrap;
    overflow-wrap: break-word;

    &.last {
      color: #007bff;
    }
  }
}
</style>
